import { render, staticRenderFns } from "./WaferLayoutDialog.vue?vue&type=template&id=0e85804a&scoped=true"
import script from "./WaferLayoutDialog.vue?vue&type=script&lang=js"
export * from "./WaferLayoutDialog.vue?vue&type=script&lang=js"
import style0 from "./WaferLayoutDialog.vue?vue&type=style&index=0&id=0e85804a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e85804a",
  null
  
)

export default component.exports